import englishAnalysisLabels from "./analysis-labels.en.json"

const HANGUL_PATTERN = /[ㄱ-ㅎㅏ-ㅣ가-힣]/
const ENGLISH_ANALYSIS_LABELS = englishAnalysisLabels as Readonly<Record<string, string>>

/**
 * 분석 API는 locale과 무관하게 한국어 분류 키를 반환한다. 필터 요청에는 원문 키가
 * 필요하므로 데이터 자체를 바꾸지 않고 화면에 표시할 라벨만 locale에 맞춰 변환한다.
 *
 * 영어 용어집에 없는 한국어 라벨은 그대로 노출하지 않는다. 새 분류가 추가됐을 때
 * 조용히 한글이 섞이는 대신 해당 항목을 숨기고 QA에서 누락을 발견하도록 fail-closed 한다.
 */
export const getHospitalAnalysisDisplayLabel = (
  label: string,
  locale: string,
): string | null => {
  const normalized = label.trim()
  if (!normalized) return null
  if (locale !== "en") return normalized

  return ENGLISH_ANALYSIS_LABELS[normalized]
    ?? (HANGUL_PATTERN.test(normalized) ? null : normalized)
}

export const hasHangul = (value: string): boolean => HANGUL_PATTERN.test(value)

export const englishHospitalAnalysisLabels = ENGLISH_ANALYSIS_LABELS
